import { render, staticRenderFns } from "./ProductBanner.vue?vue&type=template&id=a647c75c&scoped=true"
import script from "./ProductBanner.vue?vue&type=script&lang=js"
export * from "./ProductBanner.vue?vue&type=script&lang=js"
import style0 from "./ProductBanner.vue?vue&type=style&index=0&id=a647c75c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a647c75c",
  null
  
)

export default component.exports